import { CalculationTypes } from 'src/modules/newCars/constants/model';
import { ModelDetailType } from 'src/modules/newCars/types';
import { formatPrice } from 'src/modules/newCars/utils/helper';
import { Typography } from 'ui';
import { TypeScales } from 'ui/primitives';
import Hero from '../../../Hero';
import LatestNews from '../../../LatestNews';
import VideoReview from '../../../VideoReview';
import Faq from '../../../content/Faq';
import ScrollableJumbo from '../../../content/ScrollableJumbo';
import CalculatedValues from '../CalculatedValues';
import { Detail } from '../Detail/Detail';
import { Header } from '../Header/Header';
import { UnderPriceCars } from '../UnderPriceCars/UnderPriceCars';
import UserReview from '../UserReview';
import Verdict from '../Verdict';
import { processModelSeoData } from 'src/modules/newCars/utils/seoContent';
import s from './Colour.module.scss';

export const Colour = ({
  content,
  strapiContent,
}: {
  content: ModelDetailType;
  strapiContent: any;
}) => {
  return (
    <div className={s.root}>
      <div className={s.image_desc}>
        <Header images={content.vehicleImages} showBottom={false} content={content}/>
        <Detail
          data={content}
          averageRating={strapiContent?.calculatedReview?.totalRating}
          showBottom={false}
          noOfRating={strapiContent?.calculatedReview?.ratingCount}
          price={`${formatPrice(
            content?.modelSeoData?.baseVariantPrice
          )} - ${formatPrice(content?.modelSeoData?.topVariantPrice)}`}
          brandSlug={content?.modelSeoData?.brandSlug}
          modelSlug={content?.modelSeoData?.modelSlug}
        />
      </div>
      <Typography
        label={`${content?.hero?.brandName} ${content?.hero?.modelName} Colours`}
        variant={TypeScales.h1}
        renderAs="H1"
        className={s.heading}
      />
      <Hero
        heroData={{
          image: content?.hero?.image,
          logo: content?.hero?.logo,
          brandName: content?.hero?.brandName,
          modelName: content?.hero?.modelName,
          minPrice: content?.hero?.minPrice,
          fuelType: content?.specifications?.fuelType,
          colors: content?.hero?.colors,
        }}
        type="model"
      />
      {!content?.hero?.fuelType.includes("ev") && <div className={s.calc_values}>
        <CalculatedValues
          type={CalculationTypes.runningCost}
          variantList={content?.variants}
          brandName={content?.hero?.brandName}
          modelName={content?.hero?.modelName}
        />
      </div>}
      
      {content && (
        <UnderPriceCars
          content={content}
        />
      )}

      {strapiContent?.news?.length && (
        <LatestNews
          data={strapiContent?.news}
          heading={`${content?.hero?.brandName} ${content?.hero?.modelName} latest news`}
        />
      )}
      {strapiContent?.userReview && (
        <UserReview
          link={`/new-cars/${content?.modelSeoData?.brandSlug}-car/${content?.modelSeoData?.modelSlug}/review`}
          ratingData={strapiContent.userReview}
          calculatedReview={strapiContent.calculatedReview}
        />
      )}
      {strapiContent?.videoReview && (
        <VideoReview data={strapiContent.videoReview} />
      )}
      {strapiContent?.carListing?.mustRead && (
        <ScrollableJumbo
          heading="Must read article"
          description={strapiContent?.carListing?.mustRead}
        />
      )}
      {strapiContent?.verdict && (
        <Verdict verdictData={strapiContent.verdict} />
      )}
      {/* <BrandAd /> */}
      {strapiContent?.carListing?.faqTitle &&
        strapiContent?.carListing?.faqContent && (
          <div className={s.faq}>
            <Faq
              faqTitle={strapiContent?.carListing?.faqTitle}
              faqContent={processModelSeoData(strapiContent?.carListing?.faqContent,content)}
            />
          </div>
     
        )}
    </div>
  );
};
